import { render, staticRenderFns } from "./SubmitRepairInfo.vue?vue&type=template&id=286bcd3c&scoped=true&lang=pug&"
import script from "./SubmitRepairInfo.vue?vue&type=script&lang=js&"
export * from "./SubmitRepairInfo.vue?vue&type=script&lang=js&"
import style0 from "./SubmitRepairInfo.vue?vue&type=style&index=0&id=286bcd3c&lang=scss&scoped=true&"
import style1 from "./SubmitRepairInfo.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286bcd3c",
  null
  
)

export default component.exports